import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Socials from "../components/about/socials";

import { useLanguage } from "../i18n/LanguageContext";

import "./styles/about.css";

const About = () => {
	const { t, messages } = useLanguage();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const seo = messages.seo.about;

	return (
		<React.Fragment>
			<Helmet>
				<title>{`${t("titles.about")} | ${t("main.siteTitle")}`}</title>
				<meta name="description" content={seo.description} />
				<meta name="keywords" content={seo.keywords.join(", ")} />
			</Helmet>

			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					<div className="about-container">
						<div className="about-main">
							<div className="about-right-side">
								<div className="title about-title">
									{messages.about.title}
								</div>

								<div className="subtitle about-subtitle">
									{messages.about.description}
								</div>
							</div>

							<div className="about-left-side">
								<div className="about-image-container">
									<div className="about-image-wrapper">
										<img
											src="about.jpg"
											alt="about"
											className="about-image"
										/>
									</div>
								</div>

								<div className="about-socials">
									<Socials />
								</div>
							</div>
						</div>
						<div className="about-socials-mobile">
							<Socials />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
